import { type RootState, useAppSelector } from '../..'
import { type DataObjectList } from '../../../models/DataObject'
import { type Division } from '../../../models/Division'

export const getLoading = (): boolean => useAppSelector((state) => state.courseCatalog?.isLoading)
export const divisionList = (): DataObjectList<Division> | undefined => useAppSelector((state: RootState) => state.courseCatalog?.divisionList)
export const divisionDepartmentList = (): Division[] | undefined => useAppSelector((state: RootState) => state.courseCatalog?.divisionDepartments)
export const actionLoading = (): boolean => useAppSelector((state) => state.courseCatalog?.actionLoading ?? false)
